"use strict";

var _typeof3 = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TOOLBAR_STYLES = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _tabbable = require("tabbable");
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));
var _Title = _interopRequireDefault(require("../Title/Title"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useFocusWithin2 = _interopRequireDefault(require("../utils/_useFocusWithin"));
var _constants = require("../utils/constants");
var _isFunction = _interopRequireDefault(require("../utils/isFunction"));
var _useAutoOverflow2 = _interopRequireDefault(require("../utils/useAutoOverflow"));
var _useFocusManager = _interopRequireDefault(require("../utils/useFocusManager"));
var _useResponsiveSizes = _interopRequireDefault(require("../utils/useResponsiveSizes"));
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _ToolbarLayout = _interopRequireDefault(require("./_ToolbarLayout"));
var _ToolbarOverflow = _interopRequireDefault(require("./ToolbarOverflow"));
var _ToolbarRegion = _interopRequireDefault(require("./_ToolbarRegion"));
var _ToolbarSeparator = _interopRequireDefault(require("./_ToolbarSeparator"));
var _responsiveOverflowUtils = require("./_responsiveOverflowUtils");
var _useArrowOnlyNavigation = _interopRequireWildcard(require("./useArrowOnlyNavigation"));
var _Toolbar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar.css") : void 0);
var _excluded = ["ariaLabel", "autoOverflow", "children", "className", "customTitle", "title", "titleProps", "toolbarStyle", "borderBottom", "borderTop", "breakpoints", "containerBreakpoints", "overflowButtonLabel", "includeSeparatorAfterTitle", "itemsSize", "onSizeChange", "overflowContainerRef", "onOverflowToggle", "overflowButtonProps", "overflowItemsSize", "tableToolbar", "toolbarProps", "overflowFromStart", "overflowOverlayProps", "overflowMaxHeight", "overflowContainerClassName", "navigationType", "hideOuterFocusRing", "ariaLabelledBy", "customOverflowMenuTrigger", "bypassChildren", "showOverflowMenu"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty2(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable react/jsx-no-bind */
var CSS_BLOCK = 'sapcnqr-toolbar';
var DISPLAY_NAME = 'Toolbar';
var START_REGION_DISPLAY_NAME = "".concat(DISPLAY_NAME, ".Start");
var CENTER_REGION_DISPLAY_NAME = "".concat(DISPLAY_NAME, ".Center");
var END_REGION_DISPLAY_NAME = "".concat(DISPLAY_NAME, ".End");
var TOOLBAR_STYLES = exports.TOOLBAR_STYLES = ['solid', 'transparent'];
var unwrapFragments = function unwrapFragments(children) {
  var unwrappedChildren = [];
  _react.default.Children.forEach(children, function (child) {
    if ( /*#__PURE__*/_react.default.isValidElement(child) && child.type === _react.default.Fragment) {
      // If the child is a Fragment, recursively unwrap its children
      unwrappedChildren = (0, _concat.default)(unwrappedChildren).call(unwrappedChildren, unwrapFragments(child.props.children));
    } else {
      // Otherwise, add the child directly
      unwrappedChildren.push(child);
    }
  });
  return unwrappedChildren;
};
var CloneChildWithRegion = function CloneChildWithRegion(child, regionName) {
  var _child$type, _child$type2, _child$props;
  return /*#__PURE__*/_react.default.cloneElement(child, _objectSpread({}, (child === null || child === void 0 || (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'Tooltip' || (child === null || child === void 0 || (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'Overlay' ? {
    targetProps: _objectSpread(_objectSpread({}, child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.targetProps), {}, {
      'data-toolbar-region': regionName
    })
  } : {
    'data-toolbar-region': regionName
  }));
};
var getChildNodes = function getChildNodes(regionNode, regionName) {
  var _regionNode$props, _context;
  var regionNodeChildren = (regionNode === null || regionNode === void 0 || (_regionNode$props = regionNode.props) === null || _regionNode$props === void 0 ? void 0 : _regionNode$props.children) || [];
  if (typeof regionNodeChildren === 'string') {
    return [regionNodeChildren];
  }
  regionNodeChildren = unwrapFragments(regionNodeChildren);
  return (0, _map.default)(_context = _react.default.Children).call(_context, regionNodeChildren, function (innerChild) {
    return /*#__PURE__*/_react.default.isValidElement(innerChild) && CloneChildWithRegion(innerChild, regionName);
  });
};

/**
 * The **Toolbar** component acts as container for components.
 * It provides the styles, responsive behavior and keyboard interactions
 * needed to display components inline.
*/
var Toolbar = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context2, _context3, _context4, _context5, _context7;
  var ariaLabel = _ref.ariaLabel,
    autoOverflow = _ref.autoOverflow,
    childrenProp = _ref.children,
    className = _ref.className,
    customTitle = _ref.customTitle,
    title = _ref.title,
    titleProps = _ref.titleProps,
    _ref$toolbarStyle = _ref.toolbarStyle,
    toolbarStyle = _ref$toolbarStyle === void 0 ? 'solid' : _ref$toolbarStyle,
    borderBottom = _ref.borderBottom,
    borderTop = _ref.borderTop,
    _ref$breakpoints = _ref.breakpoints,
    breakpoints = _ref$breakpoints === void 0 ? {
      md: 600,
      lg: 1024,
      xl: 1440,
      xxl: 1920
    } : _ref$breakpoints,
    containerBreakpoints = _ref.containerBreakpoints,
    overflowButtonLabel = _ref.overflowButtonLabel,
    includeSeparatorAfterTitle = _ref.includeSeparatorAfterTitle,
    _ref$itemsSize = _ref.itemsSize,
    itemsSize = _ref$itemsSize === void 0 ? 'lg' : _ref$itemsSize,
    onSizeChange = _ref.onSizeChange,
    overflowContainerRef = _ref.overflowContainerRef,
    onOverflowToggle = _ref.onOverflowToggle,
    overflowButtonProps = _ref.overflowButtonProps,
    overflowItemsSize = _ref.overflowItemsSize,
    tableToolbar = _ref.tableToolbar,
    toolbarProps = _ref.toolbarProps,
    overflowFromStart = _ref.overflowFromStart,
    overflowOverlayProps = _ref.overflowOverlayProps,
    overflowMaxHeight = _ref.overflowMaxHeight,
    overflowContainerClassName = _ref.overflowContainerClassName,
    _ref$navigationType = _ref.navigationType,
    navigationType = _ref$navigationType === void 0 ? 'arrowKeysOnly' : _ref$navigationType,
    hideOuterFocusRing = _ref.hideOuterFocusRing,
    ariaLabelledBy = _ref.ariaLabelledBy,
    customOverflowMenuTrigger = _ref.customOverflowMenuTrigger,
    bypassChildren = _ref.bypassChildren,
    showOverflowMenu = _ref.showOverflowMenu,
    otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    currentWidth = _useState2[0],
    setCurrentWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(showOverflowMenu),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    overflowOpen = _useState4[0],
    setOverflowOpen = _useState4[1];
  (0, _react.useEffect)(function () {
    setOverflowOpen(showOverflowMenu);
  }, [showOverflowMenu]);
  var internalToolbarContainerRef = (0, _react.useRef)(null);
  var internalToolbarRef = (0, _react.useRef)();
  var _useFocusWithin = (0, _useFocusWithin2.default)({
      targetElement: internalToolbarContainerRef.current
    }),
    isFocused = _useFocusWithin.isFocused;
  var overflowMenuRef = (0, _react.useRef)();
  var liveRegionRef = (0, _react.useRef)(null);
  var useLiveRegion = (0, _react.useRef)(false);
  var overflowKey = (0, _useUniqueId.default)();
  var classnames = _bind.default.bind(_Toolbar.default);
  var children = unwrapFragments(childrenProp);
  var childrenCount = _react.default.Children.count(children);
  var bypassChildrenCount = _react.default.Children.count(bypassChildren);
  var startProps = {};
  var centerProps = {};
  var endProps = {};
  var start = childrenCount ? (0, _map.default)(_context2 = _react.default.Children).call(_context2, children, function (eachChild) {
    var _eachChild$type;
    if (!eachChild || !eachChild.type || !eachChild.props) {
      return null;
    }
    var childName = (_eachChild$type = eachChild.type) === null || _eachChild$type === void 0 ? void 0 : _eachChild$type.displayName;
    if (childName === START_REGION_DISPLAY_NAME) {
      startProps = eachChild.props;

      // include all the children of the Toolbar.Start component
      return getChildNodes(eachChild, 'start');
    }
    if (childName !== CENTER_REGION_DISPLAY_NAME && childName !== END_REGION_DISPLAY_NAME) {
      // include all the children of the Toolbar component
      // that are not Toolbar.Start, Toolbar.Center, or Toolbar.End
      return CloneChildWithRegion(eachChild, 'start');
    }

    // exclude all the children of the Toolbar.Center and Toolbar.End components
    return null;
  }) : [];
  var center = childrenCount ? (0, _map.default)(_context3 = _react.default.Children).call(_context3, children, function (eachChild) {
    var _eachChild$type2;
    if ((eachChild === null || eachChild === void 0 || (_eachChild$type2 = eachChild.type) === null || _eachChild$type2 === void 0 ? void 0 : _eachChild$type2.displayName) === CENTER_REGION_DISPLAY_NAME) {
      centerProps = eachChild.props;
      return getChildNodes(eachChild, 'center');
    }
    return null;
  }) : [];
  var end = childrenCount ? (0, _map.default)(_context4 = _react.default.Children).call(_context4, children, function (eachChild) {
    var _eachChild$type3;
    if ((eachChild === null || eachChild === void 0 || (_eachChild$type3 = eachChild.type) === null || _eachChild$type3 === void 0 ? void 0 : _eachChild$type3.displayName) === END_REGION_DISPLAY_NAME) {
      endProps = eachChild.props;
      return getChildNodes(eachChild, 'end');
    }
    return null;
  }) : [];
  var overflowMaps = (0, _react.useMemo)(function () {
    if (autoOverflow) return {};
    var smMap = {};
    var mdMap = {};
    var lgMap = {};
    var xlMap = {};
    var xxlMap = {};
    var mapChildLayout = function mapChildLayout(currentChild, sizeMaps) {
      var _currentChild$type, _currentChild$type2;
      if ((currentChild === null || currentChild === void 0 || (_currentChild$type = currentChild.type) === null || _currentChild$type === void 0 ? void 0 : _currentChild$type.displayName) === 'ToolbarLayout') {
        var _currentChild$props = currentChild.props,
          overflowOrder = _currentChild$props.overflowOrder,
          _currentChild$props$c = _currentChild$props.children,
          grandChildren = _currentChild$props$c === void 0 ? [] : _currentChild$props$c;
        (0, _responsiveOverflowUtils.forEachSize)(function (eachSize) {
          if (currentChild.props[eachSize] === 'overflow') {
            (0, _responsiveOverflowUtils.addOverflowItemsToSizeMap)(sizeMaps[eachSize], overflowOrder, grandChildren);
          }
        });
      } else if ([START_REGION_DISPLAY_NAME, CENTER_REGION_DISPLAY_NAME, END_REGION_DISPLAY_NAME].indexOf(currentChild === null || currentChild === void 0 || (_currentChild$type2 = currentChild.type) === null || _currentChild$type2 === void 0 ? void 0 : _currentChild$type2.displayName) !== -1 || (currentChild === null || currentChild === void 0 ? void 0 : currentChild.type) === _react.default.Fragment) {
        _react.default.Children.forEach(currentChild.props.children, function (grandChild) {
          mapChildLayout(grandChild, sizeMaps);
        });
      }
    };

    // allow xxl to inherit xl if not defined - we introduced xxl after the breakpoints
    // prop was already established, this is to prevent
    // the breaking change of xxl being required
    if ((0, _keys.default)(xxlMap).length === 0) {
      xxlMap = xlMap;
    }
    _react.default.Children.forEach(children, function (mainChild) {
      mapChildLayout(mainChild, {
        sm: smMap,
        md: mdMap,
        lg: lgMap,
        xl: xlMap,
        xxl: xxlMap
      });
    });
    return {
      sm: smMap,
      md: mdMap,
      lg: lgMap,
      xl: xlMap,
      xxl: xxlMap
    };
  }, [autoOverflow, childrenCount]);
  var classes = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context5 = "".concat(CSS_BLOCK, "--")).call(_context5, toolbarStyle), !!toolbarStyle), "".concat(CSS_BLOCK, "--border-bottom"), !!borderBottom), "".concat(CSS_BLOCK, "--border-top"), !!borderTop), "".concat(CSS_BLOCK, "__table"), !!tableToolbar), "".concat(CSS_BLOCK, "--outline"), !hideOuterFocusRing && (navigationType === 'arrowKeysOnly' || navigationType === 'tabAndArrowsKeys') && isFocused));
  (0, _useResponsiveSizes.default)(function (currentSize) {
    setCurrentWidth(currentSize);
    onSizeChange === null || onSizeChange === void 0 || onSizeChange(currentSize);
  }, internalToolbarRef, breakpoints, containerBreakpoints);
  var handleOverflowToggle = function handleOverflowToggle(open) {
    setOverflowOpen(!!open);
    if ((0, _isFunction.default)(onOverflowToggle)) {
      onOverflowToggle(open);
    }
  };
  var renderOverflowMenu = function renderOverflowMenu(overflowItems) {
    return /*#__PURE__*/_react.default.createElement(_ToolbarOverflow.default, {
      cssBlock: CSS_BLOCK,
      overflowItemsSize: overflowItemsSize === undefined ? itemsSize : overflowItemsSize,
      overflowButtonProps: overflowButtonProps,
      ref: (0, _reactMergeRefs.default)([overflowMenuRef, overflowContainerRef]),
      overflowButtonLabel: overflowButtonLabel,
      onOverflowToggle: handleOverflowToggle,
      key: overflowKey,
      overlayProps: overflowOverlayProps,
      maxHeight: overflowMaxHeight,
      showOverflowMenu: overflowOpen
    }, overflowItems);
  };
  if (!autoOverflow && (0, _keys.default)((overflowMaps === null || overflowMaps === void 0 ? void 0 : overflowMaps[currentWidth]) || {}).length) {
    if (overflowFromStart) {
      start.unshift(renderOverflowMenu((0, _responsiveOverflowUtils.getWidthItems)(overflowMaps, currentWidth)));
    } else {
      end.push(renderOverflowMenu((0, _responsiveOverflowUtils.getWidthItems)(overflowMaps, currentWidth)));
    }
  }
  var addChildProps = function addChildProps(classnamesFn, child, childProps) {
    if (childProps['data-tooltip-target'] === true) {
      return {};
    }
    if (childProps['data-skip-toolbar'] === true) {
      return {};
    }
    if (child.displayName === 'Toolbar.End' || child.displayName === 'Toolbar.Center' || child.displayName === 'Toolbar.Start') {
      return {};
    }
    if (childProps['data-nui-widgets'] === 'menu-button-trigger') {
      // if Button is a menu trigger, skip setting
      // overflow props.
      return {};
    }
    if (child.displayName === 'ToolbarLayout') {
      var widthBehavior = (0, _responsiveOverflowUtils.getWidthBehavior)(childProps, currentWidth);
      return {
        className: classnamesFn(childProps.className, "".concat(CSS_BLOCK, "__layout")),
        hide: widthBehavior === 'hide' || widthBehavior === 'overflow',
        replaceWith: (0, _typeof2.default)(widthBehavior) === 'object' && widthBehavior
      };
    }
    if (child.displayName === 'ToolbarSeparator') {
      return {
        size: itemsSize
      };
    }
    if (child.displayName === 'Tooltip') {
      var _childProps$targetPro;
      return {
        targetProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.targetProps), {}, {
          className: classnamesFn(childProps === null || childProps === void 0 || (_childProps$targetPro = childProps.targetProps) === null || _childProps$targetPro === void 0 ? void 0 : _childProps$targetPro.className, "".concat(CSS_BLOCK, "__item"))
        })
      };
    }
    if (child.displayName === 'Link' || child.displayName === 'IconLink') {
      var _context6;
      return {
        size: itemsSize,
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, "".concat(CSS_BLOCK, "__item"), "".concat(CSS_BLOCK, "__link"), (0, _concat.default)(_context6 = "".concat(CSS_BLOCK, "__link--")).call(_context6, itemsSize || 'lg')),
        matchButtonHeight: true,
        innerTextClasses: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.innerTextClasses, "".concat(CSS_BLOCK, "__text"))
      };
    }
    if (child.displayName === 'Checkbox') {
      return {
        size: itemsSize,
        inline: true,
        className: classnamesFn(childProps.className, "".concat(CSS_BLOCK, "__item"))
      };
    }
    if (child.displayName === 'FormField') {
      var _childProps$labelProp, _childProps$helpTextP, _childProps$inputProp;
      useLiveRegion.current = true;
      return {
        layout: 'horizontal',
        className: classnamesFn(childProps.className),
        validationOverlayProps: _objectSpread(_objectSpread({}, childProps.validationOverlayProps), {}, {
          customLiveRegionRef: liveRegionRef
        }),
        labelProps: _objectSpread(_objectSpread({}, childProps.labelProps), {}, {
          className: classnamesFn(childProps === null || childProps === void 0 || (_childProps$labelProp = childProps.labelProps) === null || _childProps$labelProp === void 0 ? void 0 : _childProps$labelProp.className, "".concat(CSS_BLOCK, "__label"))
        }),
        helpTextProps: _objectSpread(_objectSpread({}, childProps.helpTextProps), {}, {
          className: classnamesFn(childProps === null || childProps === void 0 || (_childProps$helpTextP = childProps.helpTextProps) === null || _childProps$helpTextP === void 0 ? void 0 : _childProps$helpTextP.className, "".concat(CSS_BLOCK, "__text"))
        }),
        inputProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.inputProps), {}, {
          onKeyDown: (0, _chainFunction.default)(childProps === null || childProps === void 0 || (_childProps$inputProp = childProps.inputProps) === null || _childProps$inputProp === void 0 ? void 0 : _childProps$inputProp.onKeyDown, function (event) {
            var _event$currentTarget, _event$currentTarget2, _event$currentTarget3;
            // suppress arrow, home, and end key events of an input in toolbar.
            // i.e. use these events to traverse the input field value
            // and not the toolbar items
            if (((0, _keycode.default)(event) === 'left' || (0, _keycode.default)(event) === 'right' || (0, _keycode.default)(event) === 'home' || (0, _keycode.default)(event) === 'end') && (navigationType === 'arrowKeysOnly' || navigationType === 'tabAndArrowsKeys') && ((event === null || event === void 0 || (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.selectionStart) !== 0 && ((0, _keycode.default)(event) === 'left' || (0, _keycode.default)(event) === 'home') || (event === null || event === void 0 || (_event$currentTarget2 = event.currentTarget) === null || _event$currentTarget2 === void 0 ? void 0 : _event$currentTarget2.selectionEnd) !== (event === null || event === void 0 || (_event$currentTarget3 = event.currentTarget) === null || _event$currentTarget3 === void 0 || (_event$currentTarget3 = _event$currentTarget3.value) === null || _event$currentTarget3 === void 0 ? void 0 : _event$currentTarget3.length) && ((0, _keycode.default)(event) === 'right' || (0, _keycode.default)(event) === 'end'))) {
              event.stopPropagation();
            }
          })
        })
      };
    }
    if (child.displayName === 'Icon') {
      return {
        size: (childProps === null || childProps === void 0 ? void 0 : childProps.size) || itemsSize
      };
    }
    if (child.displayName === 'SplitButton') {
      return {
        size: itemsSize,
        className: classnamesFn(childProps.className, "".concat(CSS_BLOCK, "__item"))
      };
    }
    return {
      size: itemsSize,
      type: tableToolbar && child.displayName === 'Button' && (childProps === null || childProps === void 0 ? void 0 : childProps.type) === 'primary' ? 'link' : childProps === null || childProps === void 0 ? void 0 : childProps.type,
      className: classnamesFn(childProps.className, "".concat(CSS_BLOCK, "__item"), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__link"), child.displayName === 'Button' && childProps.type === 'link' || tableToolbar && child.displayName === 'Button' && (childProps === null || childProps === void 0 ? void 0 : childProps.type) === 'primary'), "".concat(CSS_BLOCK, "__compact"), child.displayName === 'Button' && childProps.type === 'link' && (childProps === null || childProps === void 0 ? void 0 : childProps.compact)))
    };
  };
  var internalOverflowContainerRef = (0, _react.useRef)();
  var overflowElement = /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({
    ariaLabel: "Placeholder",
    iconName: "kebab"
  }, overflowButtonProps, {
    className: classnames("".concat(CSS_BLOCK, "__overflow-trigger"), overflowButtonProps === null || overflowButtonProps === void 0 ? void 0 : overflowButtonProps.className)
  }));
  var _useAutoOverflow = (0, _useAutoOverflow2.default)({
      disable: !autoOverflow,
      overflowFromStart: overflowFromStart,
      itemGap: 6,
      targetRef: internalOverflowContainerRef,
      children: (0, _concat.default)(_context7 = []).call(_context7, (0, _toConsumableArray2.default)(start), (0, _toConsumableArray2.default)(center), (0, _toConsumableArray2.default)(end)),
      overflowElement: overflowElement,
      overflownProps: function overflownProps(child, autoOverflowProps) {
        var _child$type3, _child$type4;
        if ((child === null || child === void 0 || (_child$type3 = child.type) === null || _child$type3 === void 0 ? void 0 : _child$type3.displayName) === 'Overlay' || (child === null || child === void 0 || (_child$type4 = child.type) === null || _child$type4 === void 0 ? void 0 : _child$type4.displayName) === 'Tooltip') {
          var _child$props2;
          return {
            targetProps: _objectSpread(_objectSpread({}, child === null || child === void 0 || (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.targetProps), autoOverflowProps)
          };
        }
        return {};
      }
    }),
    _useAutoOverflow$chil = _useAutoOverflow.childrenToRender,
    childrenToRender = _useAutoOverflow$chil === void 0 ? [] : _useAutoOverflow$chil,
    _useAutoOverflow$over = _useAutoOverflow.overflowChildrenToRender,
    overflowChildrenToRender = _useAutoOverflow$over === void 0 ? [] : _useAutoOverflow$over;
  (0, _useArrowOnlyNavigation.default)({
    containerRef: internalToolbarContainerRef,
    disabled: navigationType !== 'arrowKeysOnly'
  });
  var allowArrowKeyNav = navigationType !== 'tabKeyOnly';
  (0, _useFocusManager.default)(_objectSpread(_objectSpread({}, allowArrowKeyNav ? {
    nextKeyCode: _keycode.default.codes.right,
    previousKeyCode: _keycode.default.codes.left
  } : {}), {}, {
    firstFocusIndex: 0,
    suppressInitialAttachment: true,
    stopKeyPressPropagation: true,
    useHomeAndEndKeys: true,
    skipEvent: function skipEvent(event) {
      var _event$target, _event$target$getAttr, _event$target2, _event$target2$getAtt, _event$target3, _event$target4, _event$target4$getAtt;
      if ((0, _keycode.default)(event) === 'tab' && navigationType === 'arrowKeysOnly' && !!internalToolbarContainerRef.current) {
        // suppress tab events if navigationType is 'arrowKeysOnly'
        var toolbarItems = (0, _tabbable.tabbable)(internalToolbarContainerRef.current);
        if (event !== null && event !== void 0 && event.shiftKey && (0, _useArrowOnlyNavigation.getPreviousEl)(toolbarItems)
        // suppress/handle 'shift + tab' only if there is a previous element
        // if there aren't any elements before the toolbar the focus
        // goes out of the DOM to the browser which we shouldn't prevent
        ) {
          event.preventDefault();
          return true;
        }
        if ((0, _useArrowOnlyNavigation.getNextEl)(toolbarItems)) {
          //
          // suppress/handle 'tab' only if there is a next element
          // if there isn't any element after the toolbar the focus
          // goes of the DOM to the browser which we shouldn't prevent
          event.preventDefault();
          return true;
        }
      }

      // skip Toolbar focus management for SegmentedButton as it
      // manages its own active descendants.
      var activeDescendantId = (_event$target = event.target) === null || _event$target === void 0 || (_event$target$getAttr = _event$target.getAttribute) === null || _event$target$getAttr === void 0 ? void 0 : _event$target$getAttr.call(_event$target, 'aria-activedescendant');

      // if there is no active descendant, don't skip focus management
      if (!activeDescendantId) {
        return false;
      }
      var firstOptionId = (_event$target2 = event.target) === null || _event$target2 === void 0 || (_event$target2 = _event$target2.firstElementChild) === null || _event$target2 === void 0 || (_event$target2$getAtt = _event$target2.getAttribute) === null || _event$target2$getAtt === void 0 ? void 0 : _event$target2$getAtt.call(_event$target2, 'id');
      var lastOptionId = (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.lastElementChild.getAttribute('id');

      // if segmented button has label get the 1st option like this:
      if (((_event$target4 = event.target) === null || _event$target4 === void 0 || (_event$target4 = _event$target4.firstElementChild) === null || _event$target4 === void 0 || (_event$target4$getAtt = _event$target4.getAttribute) === null || _event$target4$getAtt === void 0 ? void 0 : _event$target4$getAtt.call(_event$target4, 'role')) === 'presentation') {
        var _event$target5, _event$target5$getAtt;
        firstOptionId = (_event$target5 = event.target) === null || _event$target5 === void 0 || (_event$target5 = _event$target5.childNodes[1]) === null || _event$target5 === void 0 || (_event$target5$getAtt = _event$target5.getAttribute) === null || _event$target5$getAtt === void 0 ? void 0 : _event$target5$getAtt.call(_event$target5, 'id');
      }

      // if the active descendant is not the first or last option, skip focus management
      return activeDescendantId !== lastOptionId && (0, _keycode.default)(event) === 'right' || activeDescendantId !== firstOptionId && (0, _keycode.default)(event) === 'left';
    }
  }), !overflowOpen && isFocused && allowArrowKeyNav, internalToolbarContainerRef);
  var getRegionChildren = function getRegionChildren(allChildren, regionName) {
    return allChildren === null || allChildren === void 0 ? void 0 : (0, _filter.default)(allChildren).call(allChildren, function (child) {
      var _child$props3, _child$props4;
      return (child === null || child === void 0 || (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3['data-toolbar-region']) === regionName || (child === null || child === void 0 || (_child$props4 = child.props) === null || _child$props4 === void 0 || (_child$props4 = _child$props4.targetProps) === null || _child$props4 === void 0 ? void 0 : _child$props4['data-toolbar-region']) === regionName;
    });
  };
  var getActualChildren = function getActualChildren(allChildren) {
    return allChildren === null || allChildren === void 0 ? void 0 : (0, _filter.default)(allChildren).call(allChildren, function (child) {
      var _child$props5;
      return !(child !== null && child !== void 0 && (_child$props5 = child.props) !== null && _child$props5 !== void 0 && _child$props5['aria-hidden']);
    });
  };
  var startChildrenToRender = start;
  var centerChildrenToRender = center;
  var endChildrenToRender = end;
  var overflowMenuTrigger = customOverflowMenuTrigger || null;
  if (autoOverflow) {
    startChildrenToRender = getRegionChildren(childrenToRender, 'start');
    centerChildrenToRender = getRegionChildren(childrenToRender, 'center');
    endChildrenToRender = getRegionChildren(childrenToRender, 'end');
    if (overflowChildrenToRender !== null && overflowChildrenToRender !== void 0 && overflowChildrenToRender.length) {
      overflowMenuTrigger = renderOverflowMenu(overflowChildrenToRender);
    }
  }
  var toolbarAriaLabel = ariaLabel;
  if (!toolbarAriaLabel && typeof title === 'string') {
    toolbarAriaLabel = title;
  }
  var contextualChildren = function contextualChildren(regionalChildren) {
    return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
      value: addChildProps.bind(null, classnames)
    }, regionalChildren);
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: classes,
    ref: (0, _reactMergeRefs.default)([ref, internalToolbarContainerRef])
  }), (typeof title === 'string' ? (0, _trim.default)(title).call(title) : title) && (customTitle ? title : /*#__PURE__*/_react.default.createElement(_Title.default, (0, _extends2.default)({
    headingLevel: 4
  }, titleProps, {
    className: classnames("".concat(CSS_BLOCK, "__title"), titleProps === null || titleProps === void 0 ? void 0 : titleProps.className)
  }), title)), includeSeparatorAfterTitle && (autoOverflow && _react.default.Children.count(getActualChildren(childrenToRender)) > 0 || !autoOverflow) && /*#__PURE__*/_react.default.createElement(_ToolbarSeparator.default, {
    role: "presentation",
    "aria-hidden": true
  }), (childrenCount > 0 || autoOverflow && _react.default.Children.count(getActualChildren(childrenToRender)) > 0) && contextualChildren( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, overflowFromStart && overflowMenuTrigger, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, toolbarProps, {
    "aria-labelledby": ariaLabelledBy,
    className: classnames("".concat(CSS_BLOCK, "__toolbar"), toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.className),
    role: "toolbar",
    "aria-label": toolbarAriaLabel,
    ref: (0, _reactMergeRefs.default)([toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.ref, internalToolbarRef])
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(overflowContainerClassName, "".concat(CSS_BLOCK, "__overflow-container"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__overflow-container--scroll"), !autoOverflow)),
    ref: internalOverflowContainerRef
  }, startChildrenToRender.length > 0 && /*#__PURE__*/_react.default.createElement(Toolbar.Start, startProps, contextualChildren(startChildrenToRender)), centerChildrenToRender.length > 0 && /*#__PURE__*/_react.default.createElement(Toolbar.Center, centerProps, contextualChildren(centerChildrenToRender)), endChildrenToRender.length > 0 && /*#__PURE__*/_react.default.createElement(Toolbar.End, endProps, contextualChildren(endChildrenToRender)), bypassChildren)), !overflowFromStart && overflowMenuTrigger)), bypassChildren && bypassChildrenCount > 0 && !autoOverflow && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, overflowFromStart && overflowMenuTrigger, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, toolbarProps, {
    "aria-labelledby": ariaLabelledBy,
    className: classnames("".concat(CSS_BLOCK, "__toolbar"), toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.className),
    role: "toolbar",
    "aria-label": toolbarAriaLabel,
    ref: (0, _reactMergeRefs.default)([toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.ref, internalToolbarRef])
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(overflowContainerClassName, "".concat(CSS_BLOCK, "__overflow-container"), "".concat(CSS_BLOCK, "__overflow-container--scroll")),
    ref: internalOverflowContainerRef
  }, /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: addChildProps.bind(null, classnames)
  }, bypassChildren))), !overflowFromStart && overflowMenuTrigger), useLiveRegion.current && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__live-region")),
    "data-test": "toolbar-status",
    "aria-live": "polite",
    role: "status",
    ref: liveRegionRef
  }));
});
Toolbar.displayName = DISPLAY_NAME;
Toolbar.propTypes = {
  /** @ignore set by TableToolbar */
  tableToolbar: _propTypes.default.bool,
  /** aria-label for the toolbar element (role="toolbar") this is required if you are using
   * a custom title (customTitle=true) OR if no title is set. */
  ariaLabel: _propTypes.default.string,
  /** aria-labelledby for the toolbar element (role="toolbar").
   * Use this to label the toolbar with an element outside the toolbar.
   */
  ariaLabelledBy: _propTypes.default.string,
  /** Collection of React components to be placed in the region. */
  children: _propTypes.default.node,
  /** Bypasses all children manipulation in **Toolbar**. Only use under certain
   * circumstances like
   * when handling your own `useAutoOverflow` hook with multiple regions.
   */
  bypassChildren: _propTypes.default.node,
  /** When using custom overflow with `bypassChildren`,
   * use this to pass your own **ToolbarOverflow** component. */
  customOverflowMenuTrigger: _propTypes.default.node,
  /** Custom classes to add to the **Toolbar** enclosing DIV. */
  className: _propTypes.default.string,
  /** Custom classes to add to the **Toolbar**'s item's container DIV. */
  overflowContainerClassName: _propTypes.default.string,
  /** A localized string or a React node to use as title (<Title /> component) for the toolbar. */
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /** Additional props to spread to the toolbar <Title />. */
  titleProps: _propTypes.default.object,
  /** Set to **true** if you're using a highly custom
   * `Toolbar.title` that is not compatible with the
   * <Title /> component to avoid accessibility
   * pitfalls (invalid nesting).
   */
  customTitle: _propTypes.default.bool,
  /** Visual style of the toolbar:
   *
   * * `solid`: will have a solid background (only in Gateway).
   * * `transparent`: no background.
   */
  toolbarStyle: _propTypes.default.oneOf(TOOLBAR_STYLES),
  /** Set to true to show a border-bottom for the toolbar. */
  borderBottom: _propTypes.default.bool,
  /** Set to true to show a border-top for the toolbar. */
  borderTop: _propTypes.default.bool,
  /** Set to true to automatically add overflowing items to a popover menu which will be added
   * at the end of the toolbar when it overflows. To fine-tune overflow behavior at
   * various breakpoints use the Toolbar.Layout component instead.
   * Do not use a mixture of both these methods.
   *
   * By default, the overflow **IconButton** will appear at the end of the **Toolbar**.
   */
  autoOverflow: _propTypes.default.bool,
  /** Set to **true** to include a visual separator after the title in the **Toolbar**.
   * When using `autoOverflow`, the
   * separator will be hidden when all toolbar items are in the overflow menu.
   */
  includeSeparatorAfterTitle: _propTypes.default.bool,
  /** Set to **true** to show overflown items from start of the toolbar instead of the end. */
  overflowFromStart: _propTypes.default.bool,
  /** Size breakpoints used in **Toolbar.Layout** relative to the viewport in pixels.
   * See standard 16 column LayoutGrid breakpoints
   *  [here](https://pages.github.concur.com/coreui/nui-layouts/latest/?path=/docs/components-layoutgrid--fully-responsive-fluid#specifications).
   * Sizes less than 'md' will be considered 'sm'.
   */
  breakpoints: _propTypes.default.shape({
    md: _propTypes.default.number.isRequired,
    lg: _propTypes.default.number.isRequired,
    xl: _propTypes.default.number.isRequired,
    xxl: _propTypes.default.number
  }),
  /**
   * Set to `true` to base the responsive behavior, for `breakpoints`, on the
   * width of the toolbar's container instead of the viewport's width.
   */
  containerBreakpoints: _propTypes.default.bool,
  /** Type of keyboard navigation to use.
   *
   * * `arrowKeysOnly`: Only arrow keys will navigate through toolbar items.
   * * `tabKeyOnly`: Only the tab key will navigate through toolbar items.
   * * `tabAndArrowsKeys`: Both tab key and arrow keys will navigate through toolbar items.
   * (this will be the default behavior when the toolbar is the first or last element in the DOM)
   */
  navigationType: _propTypes.default.oneOf(['arrowKeysOnly', 'tabKeyOnly', 'tabAndArrowsKeys']),
  /** An outer focus ring is shown when navigationType is "arrowKeysOnly"
   * or "tabAndArrowsKey" and any toolbar element has focus.
   *  Set to **true** to hide this outer focus outline in all cases. */
  hideOuterFocusRing: _propTypes.default.bool,
  /** Size of Toolbar items. */
  itemsSize: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** CSS max-height property for the overflow popup. */
  overflowMaxHeight: _propTypes.default.string,
  /** Localized string aria-label for toolbar overflow menu trigger button.
   * Don't forget to set this if using overflow behavior at any breakpoint.
   */
  overflowButtonLabel: _propTypes.default.string,
  /** Additional props to spread to the overflow trigger button. */
  overflowButtonProps: _propTypes.default.object,
  /** Additional props to spread to the overflow Overlay. */
  overflowOverlayProps: _propTypes.default.object,
  /** Attach a ref to the `<div>` wrapper containing overflow items. */
  overflowContainerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** Size of overflowing items in the overflow menu. */
  overflowItemsSize: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** Additional props to spread `<div role="toolbar">` element. */
  toolbarProps: _propTypes.default.object,
  /** Set to `true` to show overflow menu. Can be used to manage the
   * state of the overflow menu after interacting with child items.
   */
  showOverflowMenu: _propTypes.default.bool,
  /** Callback function for when toolbar size crosses
   *  any size breakpoints defined in `breakpoints`. */
  onSizeChange: _propTypes.default.func,
  /** Callback function for when toolbar overflow menu popover
   *  is opened or closed.
   *
   * @param {Boolean} open - indicating if overflow menu is opened.  */
  onOverflowToggle: _propTypes.default.func
};
Toolbar.Start = (0, _ToolbarRegion.default)(START_REGION_DISPLAY_NAME);
Toolbar.Center = (0, _ToolbarRegion.default)(CENTER_REGION_DISPLAY_NAME);
Toolbar.End = (0, _ToolbarRegion.default)(END_REGION_DISPLAY_NAME);
Toolbar.Layout = _ToolbarLayout.default;
Toolbar.Separator = _ToolbarSeparator.default;
var _default = exports.default = Toolbar;